<template>
  <div class="solution-content" :class="{ hidden: !isActive }">
    <div class="solution-image">
      <img :src="item.image">
    </div>
    <h5 class="solution-heading wwf-font">{{ item.title }}</h5>
    <div class="solution-text">
      <p>{{ item.text }}</p>

      <div class="solution-links">
        <a v-for="(link, i) in item.links" :key="'link' + i" :href="link.url">
          <div class="link-image" :style="'background-image: url('+ link.image +')'"></div>
          <span>{{ link.name }}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SolutionsContent",

  props: {
    item: {
      type: Object,
      required: true,
    },
    isActive: {
      type: Boolean,
    },
  },
};
</script>

<style scoped>
.solution-content {
  display: grid;
  grid-template: auto 1fr / 1fr 3fr;
  gap: 1rem;
  padding: 1rem 1rem 2rem;
  background: var(--wwfGreyED);
}

.solution-heading {
  margin: 0;
  font-size: 1.5rem;
}

.solution-text {
  grid-column: span 2;
}

.solution-links {
  display: grid;
  grid-template: repeat(3, auto) / 1fr;
  gap: 1rem;
  margin-top: 1rem;
}

.solution-links a {
  border-radius: 4px;
  overflow: hidden;
}

.solution-links span {
  display: block;
  padding: 0.5rem 0;
  color: var(--wwfWhite);
  background: var(--wwfOrange);
  text-align: center;
  text-transform: uppercase;
}

.link-image {
  padding-top: 55%;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-color: var(--wwfGreyDE);
}

.wwf-font {
  font-family: "WWFRegular", sans-serif;
  font-weight: 400;
}

.hidden {
  display: none;
}

@media only screen and (min-width: 768px) {
  .solution-content {
    grid-column: 1 / -1;
    grid-row: -2;
    background: none;
  }

  .solution-image {
    grid-row: span 2;
  }

  .solution-text {
    grid-column: span 1;
  }

  .solution-links {
    grid-template: 1fr / repeat(3, 1fr);
  }
}

@media only screen and (min-width: 1200px) {
  .solution-content {
    gap: 2rem;
    padding-top: 3rem;
  }
  
  .solution-links {
    gap: 2rem;
    margin-top: 2rem;
  }
}
</style>


// WEBPACK FOOTER //
// SolutionsContent.vue?9bc81940